<ish-account-profile-password [error]="userError$ | async" (updatePassword)="updateUserPassword($event)" />

<ish-loading *ngIf="userLoading$ | async" />
